export interface PeopleFeedbackState {
    live?: PeopleFeedback;
    cache?: PeopleFeedback;
    directory?: PeopleFeedback;
}

export interface PeopleFeedback {
    TraceId: string;
    TimeStamp: string;
    QueryString: string;
    SuggestionSource: string;
    RawResponse: string;
}

export function createPeopleFeedback(): PeopleFeedback {
    return {
        TraceId: '',
        TimeStamp: '',
        QueryString: '',
        SuggestionSource: '',
        RawResponse: '',
    };
}
